import React from "react";
import FormReview from "../../../components/Compos Validation/index.js";

/**
 * Modal de conferência/revisão dos dados do TCE antes do envio.
 *
 * @param {object} props
 * @param {boolean} props.showReview - Controla visibilidade do modal
 * @param {Function} props.onClose - Callback disparado para fechar o modal ou editar
 * @param {Array} props.reviewData - Estrutura de seções gerada por buildReviewData
 * @param {Function} props.onSubmit - Callback de submissão definitiva após confirmação
 */
export const TceReviewModal = ({
  showReview,
  onClose,
  reviewData,
  onSubmit,
}) => {
  if (!showReview) return null;

  return (
    <div
      className="tca-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
      role="dialog"
      aria-modal="true"
    >
      <div className="tca-modal-content">
        <FormReview
          data={reviewData}
          onEdit={onClose}
          onSubmit={onSubmit}
          confirmMessage="Tem certeza que deseja enviar o TCE?"
        />
      </div>
    </div>
  );
};

export default TceReviewModal;
